import React, { PropsWithChildren, ReactElement, useContext } from 'react';

export interface ImageMapShareContextValue {
  /** 카카오 공유하기 객체 */
  kakaoApi?: any;
  /** 카카오 공유하기 templateId */
  kakaoTemplateId?: number;
  /** 공유할 때 사용할 정보, jsx-editor에서는 어떤 형태로 넘어오는지 알 필요 없어서 any로 둡니다. */
  templateArgs?: any;
  /** 이미지 클릭 시 callback */
  onClick?: () => void;
}

const ImageMapShareContext = React.createContext<ImageMapShareContextValue>({});
export const useImageMapShareContext = (): ImageMapShareContextValue => useContext(ImageMapShareContext);

export function ImageMapShareContextProvider({
  children,
  value = {},
}: PropsWithChildren<{ value?: ImageMapShareContextValue }>): ReactElement {
  return (
    <ImageMapShareContext.Provider value={value}>
      { children }
    </ImageMapShareContext.Provider>
  );
}
